import { render, staticRenderFns } from "./ProfileInnerHeaderItem.vue?vue&type=template&id=6efc656b&scoped=true&"
import script from "./ProfileInnerHeaderItem.vue?vue&type=script&lang=ts&"
export * from "./ProfileInnerHeaderItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInnerHeaderItem.vue?vue&type=style&index=0&id=6efc656b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc656b",
  null
  
)

export default component.exports